"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.projectLevelOptions = void 0;
var projectLevelOptions = exports.projectLevelOptions = [{
  name: '国家级',
  id: '国家级'
}, {
  name: '省级',
  id: '省级'
}, {
  name: '校级',
  id: '校级'
}];